import { render, staticRenderFns } from "./LiteracyComponent4.vue?vue&type=template&id=b9bd56a6&scoped=true&"
import script from "./LiteracyComponent4.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bd56a6",
  null
  
)

export default component.exports